// src/services/bookingApi.js
const API_URL = '/api';

const handleResponse = async (res) => {
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || errorData.message || `HTTP error! status: ${res.status}`);
  }
  return res.json();
};

const api = {
  testConnection: () => fetch(`${API_URL}/test`).then(handleResponse),

  getServices: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return fetch(`${API_URL}/services?${queryString}`).then(handleResponse);
  },

  createService: (data) =>
    fetch(`${API_URL}/services`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(handleResponse),

  updateService: (id, data) =>
    fetch(`${API_URL}/services/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(handleResponse),

  deleteService: (id) =>
    fetch(`${API_URL}/services/${id}`, {
      method: 'DELETE'
    }).then(handleResponse),

  getAvailableSlots: (date, serviceId) =>
    fetch(`${API_URL}/availability/slots?date=${date}&serviceId=${serviceId}`)
      .then(handleResponse),

  getAppointments: (filters = {}) => {
    const cleanFilters = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v != null && v !== ''));
    const params = new URLSearchParams(cleanFilters).toString();
    return fetch(`${API_URL}/appointments?${params}`).then(handleResponse);
  },

  createAppointment: (data) =>
    fetch(`${API_URL}/appointments`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(handleResponse),

  cancelAppointment: (id) =>
    fetch(`${API_URL}/appointments/${id}/cancel`, {
      method: 'PUT'
    }).then(handleResponse),

  getLocations: () =>
    fetch(`${API_URL}/Locations/getAllLocations`).then(handleResponse),

  getCategories: () =>
    fetch(`${API_URL}/service-categories`).then(handleResponse),

  createCategory: (data) =>
    fetch(`${API_URL}/service-categories`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(handleResponse)
};

// Export par défaut
export default api;

// Export nommé aussi (optionnel)
export { api };